import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SclCsvParserService {

  constructor() {
  }

  getBaby() {
    const Baby = {
      BAD_DELIMITERS: undefined, BYTE_ORDER_MARK: undefined,
      DefaultDelimiter: undefined, RECORD_SEP: undefined, UNIT_SEP: undefined
    };
    Baby.BAD_DELIMITERS = ['\r', '\n', '"', Baby.BYTE_ORDER_MARK];

    return Baby;
  }

  Parser(config?) {

    const Baby = this.getBaby();

    // Unpack the config object
    config = config || {};
    let delim = config.delimiter;
    let newline = config.newline;
    let comments = config.comments;
    const step = config.step;
    const preview = config.preview;
    const fastMode = config.fastMode;

    // Delimiter must be valid
    if (typeof delim !== 'string'
      || delim.length !== 1
      || Baby.BAD_DELIMITERS.indexOf(delim) > -1) {
      delim = ',';
    }


    // Comment character must be valid
    if (comments === delim) {
      throw new Error('Comment character same as delimiter');
    } else if (comments === true) {
      comments = '#';
    } else if (typeof comments !== 'string'
      || Baby.BAD_DELIMITERS.indexOf(comments) > -1) {
      comments = false;
    }
    // Newline must be valid: \r, \n, or \r\n
    if (newline !== '\n' && newline !== '\r' && newline !== '\r\n') {
      newline = '\n';
    }

    // We're gonna need these at the Parser scope
    let cursor = 0;
    let aborted = false;

    function parse(input) {
      // For some reason, in Chrome, this speeds things up (!?)
      if (typeof input !== 'string') {
        throw new Error('Input must be a string');
      }

      // We don't need to compute some of these every time parse() is called,
      // but having them in a more local scope seems to perform better
      const inputLen = input.length;
      const delimLen = delim.length;
      const newlineLen = newline.length;
      const commentsLen = comments.length;
      const stepIsFunction = typeof step === 'function';

      // Establish starting state
      cursor = 0;
      let data = [];
      let errors = [];
      let row = [];

      if (!input) {
        return returnable();
      }

      if (fastMode) {
        // Fast mode assumes there are no quoted fields in the input
        const rows = input.split(newline);
        for (let i = 0; i < rows.length; i++) {
          if (comments && rows[i].substr(0, commentsLen) === comments) {
            continue;
          }

          if (stepIsFunction) {
            data = [rows[i].split(delim)];
            doStep();
            if (aborted) {
              return returnable();
            }

          } else {
            data.push(rows[i].split(delim));
          }

          if (preview && i >= preview) {
            data = data.slice(0, preview);
            return returnable(true);
          }
        }
        return this.returnable();
      }

      let nextDelim = input.indexOf(delim, cursor);
      let nextNewline = input.indexOf(newline, cursor);

      // Parser loop
      for (; ;) {
        // Field has opening quote
        if (input[cursor] === '"') {
          // Start our search for the closing quote where the cursor is
          let quoteSearch = cursor;

          // Skip the opening quote
          cursor++;

          for (; ;) {
            // Find closing quote
            quoteSearch = input.indexOf('"', quoteSearch + 1);

            if (quoteSearch === -1) {
              // No closing quote... what a pity
              errors.push({
                type: 'Quotes',
                code: 'MissingQuotes',
                message: 'Quoted field unterminated',
                row: data.length,	// row has yet to be inserted
                index: cursor
              });
              return finish();
            }

            if (quoteSearch === inputLen - 1) {
              // Closing quote at EOF
              row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
              data.push(row);
              if (stepIsFunction) {
                doStep();
              }
              return this.returnable();
            }

            // If this quote is escaped, it's part of the data; skip it
            // tslint:disable-next-line:triple-equals
            if (input[quoteSearch + 1] == '"') {
              quoteSearch++;
              continue;
            }

            if (input[quoteSearch + 1] === delim) {
              // Closing quote followed by delimiter
              row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
              cursor = quoteSearch + 1 + delimLen;
              nextDelim = input.indexOf(delim, cursor);
              nextNewline = input.indexOf(newline, cursor);
              break;
            }

            if (input.substr(quoteSearch + 1, newlineLen) === newline) {
              // Closing quote followed by newline
              row.push(input.substring(cursor, quoteSearch).replace(/""/g, '"'));
              saveRow(quoteSearch + 1 + newlineLen);
              nextDelim = input.indexOf(delim, cursor);	// because we may have skipped the nextDelim in the quoted field

              if (stepIsFunction) {
                doStep();
                if (aborted) {
                  return this.returnable();
                }
              }

              if (preview && data.length >= preview) {
                return returnable(true);
              }

              break;
            }
          }

          continue;
        }

        // Comment found at start of new line
        if (comments && row.length === 0 && input.substr(cursor, commentsLen) === comments) {
          if (nextNewline === -1) {	// Comment ends at EOF
            return this.returnable();
          }
          cursor = nextNewline + newlineLen;
          nextNewline = input.indexOf(newline, cursor);
          nextDelim = input.indexOf(delim, cursor);
          continue;
        }

        // Next delimiter comes before next newline, so we've reached end of field
        if (nextDelim !== -1 && (nextDelim < nextNewline || nextNewline === -1)) {
          row.push(input.substring(cursor, nextDelim));
          cursor = nextDelim + delimLen;
          nextDelim = input.indexOf(delim, cursor);
          continue;
        }

        // End of row
        if (nextNewline !== -1) {
          row.push(input.substring(cursor, nextNewline));
          saveRow(nextNewline + newlineLen);

          if (stepIsFunction) {
            doStep();
            if (aborted) {
              return this.returnable();
            }
          }

          if (preview && data.length >= preview) {
            return returnable(true);
          }

          continue;
        }

        break;
      }


      return finish();


      // Appends the remaining input from cursor to the end into
      // row, saves the row, calls step, and returns the results.
      function finish() {
        row.push(input.substr(cursor));
        data.push(row);
        cursor = inputLen;	// important in case parsing is paused
        if (stepIsFunction) {
          doStep();
        }
        return returnable();
      }

      // Appends the current row to the results. It sets the cursor
      // to newCursor and finds the nextNewline. The caller should
      // take care to execute user's step function and check for
      // preview and end parsing if necessary.
      function saveRow(newCursor) {
        data.push(row);
        row = [];
        cursor = newCursor;
        nextNewline = input.indexOf(newline, cursor);
      }

      // Returns an object with the results, errors, and meta.
      function returnable(stopped?) {
        return {
          data: data,
          errors: errors,
          meta: {
            delimiter: delim,
            linebreak: newline,
            aborted: aborted,
            truncated: !!stopped
          }
        };
      }

      // Executes the user's step function and resets data & errors.
      function doStep() {
        step(returnable());
        data = [], errors = [];
      }
    }

    // Sets the abort flag
    function abort() {
      aborted = true;
    }

    // Gets the cursor position
    function getCharIndex() {
      return cursor;
    }
  }

}

